/* eslint-disable jsx-a11y/heading-has-content */
import classnames from 'classnames'
import { bool, node, oneOfType, string } from 'prop-types'

import imageUrlSmall from 'shared/propsMocks/images/80x80.png'
import './BannerCard.scss'
import { isTablet } from 'shared/utils/deviceClassUtils'
import Image from 'views/components/atoms/Image'
import Device from 'views/components/utils/Device'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'

const BannerCard = ({
  title,
  imageURL,
  text,
  link,
  openInNewTab,
  cardClasses,
  boxClasses,
  deviceClass,
}) => {
  const cardClassNames = classnames('o-BannerCard', cardClasses)

  const boxClassNames = classnames(
    'a-box a-box--white u-no-margin--bottom',
    {
      'l-flex l-flex--vertical-stretch l-flex--justify-content--start':
        !isTablet(deviceClass),
    },
    boxClasses
  )

  const cardMainTextClasses = classnames('u-color--dark a-break-long-words', {
    'u-margin--left': !isTablet(deviceClass),
  })

  return (
    <div className={cardClassNames}>
      <a
        href={link}
        className="a-link--no-underline"
        target={openInNewTab ? '_blank' : '_self'}
        rel="noreferrer"
      >
        <div className={boxClassNames}>
          <p className="a-h4 u-font-weight--bold u-no-margin">{title}</p>
          <div className="l-flex l-flex--start u-margin--top">
            <Device mobile desktop>
              {(!imageURL || typeof imageURL === 'string') && (
                <Image
                  src={imageURL || imageUrlSmall}
                  className="u-border-radius"
                  srcWidth={80}
                  srcHeight={80}
                />
              )}
              {imageURL && typeof imageURL !== 'string' && (
                <div className="o-header-new-banners">{imageURL}</div>
              )}
            </Device>
            <div className={cardMainTextClasses}>{text}</div>
          </div>
        </div>
      </a>
    </div>
  )
}

BannerCard.propTypes = {
  title: oneOfType([node, string]),
  imageURL: node,
  text: string.isRequired,
  link: string.isRequired,
  openInNewTab: bool,
  cardClasses: string,
  boxClasses: string,
  deviceClass: string.isRequired,
}

BannerCard.defaultProps = {
  imageURL: undefined,
  text: undefined,
  title: undefined,
  link: undefined,
  cardClasses: undefined,
  boxClasses: undefined,
}

export default withShopAndRuntimeConfig(BannerCard)
